import { BUTTON_COLOR_PATH } from '@wix/communities-forum-client-commons/dist/src/constants/wix-params';
import withSettingsColor from './with-settings-color';

export default withSettingsColor({
  path: BUTTON_COLOR_PATH,
  propName: 'buttonColor',
  alpha: 1,
  siteColorFallback: 'color-8',
});
